export default "__VITE_ASSET__CA$EKCMj__"